module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/new/arrow-95e36a7aeae4c9dd0870356bd74aa7b4.svg";